export const environment = {
	production: false,
	APIEndpoint: 'https://api.dev.cropmanage.ucanr.edu',
	CASP_LOGIN_URL: 'http://www.almondstewardship.org/',
	GoogleClientId: '566280991114-uhdiohuu7k8p1enlh9r28hclcq3mbv0p.apps.googleusercontent.com'
};
